import { Component } from 'react';
import { withRouter } from 'react-router-dom'

import Train from '../../services/train.js';
import User from '../../services/User.js';
import Element from '../../services/Element.js';
import Notification from '../../services/Notification.js';

class TwitterSignup extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {}

    let queryParams = new URLSearchParams(props.location.search);

    let oauth_token = queryParams.get('oauth_token');
    let oauth_verifier = queryParams.get('oauth_verifier');

    this.signup({oauth_token, oauth_verifier})
  }

  signup({oauth_token, oauth_verifier}) {

    Train.twitterSignup({ oauth_token, oauth_verifier})
    .then((result) => {
      User.startSession(result.token);
      let user = {user: User.getId(), name: User.getName()};
      Notification.show(`Welcome, ${User.getName()}`, 'success');
      this.props.history.push(Element.url('user', user));
      
    })
    .catch((error) => {
      Notification.show(`Error signing up with Twitter`, 'error');
      this.props.history.push('/');
    });
  }

  render() {
    return null;
  }

}

export default withRouter(TwitterSignup);



// WEBPACK FOOTER //
// ./src/js/components/signup/TwitterSignup.jsx